import React, { useState, useEffect } from 'react';
import { initOneSignal, registerForPush, isSubscribed, unsubscribe } from '../lib/onesignal';
import { Bell } from 'lucide-react';

export default function PushButton() {
  const [registered, setRegistered] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    initOneSignal();
    // Check if already subscribed using v16 API
    isSubscribed().then(subscribed => {
      setRegistered(subscribed);
    });
  }, []);

  async function handleSubscribe() {
    setLoading(true);
    try {
      const playerId = await registerForPush();
      if (!playerId) {
        alert('No player id returned — make sure you allowed notifications or check console.');
        setLoading(false);
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/notifications/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ playerId }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('[PushButton] Registration successful:', data);
        setRegistered(true);
      } else {
        console.error('[PushButton] Registration failed:', response.status);
        alert('Error al registrar la suscripción');
      }
    } catch (err) {
      console.error('subscribe error', err);
      alert('Error subscribing for notifications — see console.');
    } finally {
      setLoading(false);
    }
  }

  async function handleUnsubscribe() {
    setLoading(true);
    try {
      await unsubscribe();
      setRegistered(false);
    } catch (err) {
      console.error('unsubscribe error', err);
    } finally {
      setLoading(false);
    }
  }

  const ariaLabel = registered ? 'Disable notifications' : 'Enable notifications';

  return (
    <div>
      <button
        aria-pressed={registered}
        aria-label={ariaLabel}
        title={ariaLabel}
        onClick={registered ? handleUnsubscribe : handleSubscribe}
        disabled={loading}
        className={`p-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-300 ${registered ? 'bg-indigo-600 text-white' : 'hover:bg-slate-100 bg-white text-slate-700'}`}
      >
        {loading ? (
          <svg className="w-5 h-5 animate-spin text-slate-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
        ) : (
          <Bell className="w-5 h-5" />
        )}
      </button>
    </div>
  );
}
